import { UUID } from '@/types/types';
import { Object3D, Vector3Tuple } from 'three';

export enum UserDataProp {
	OBJECT_TYPE = 'object_type',
	TARGET = 'target',
	TRANSLATION_AXES = 'translation_axes',
	TRANSLATION_STEPS = 'translation_steps',
	IS_ACCESSORY = 'is_accessory',
	IS_ACCESSORY_HOST = 'is_accessory_host',
	ADJUST_AXIS = 'adjust_axis',
	CHILD_ACCESSORY_NAME = 'child_accessory_name',
	IS_HIDDEN = 'is_hidden',
	SLOT_NAME = 'slot_name',
	DEFAULT_SLOTS = 'default_slots',
	SLOT_AXIS = 'slot_axis',
	SLOT_ID = 'slot_id',
}

export enum AxisIndex {
	X,
	Y,
	Z,
}

export enum CustomObjectName {
	SLOTS = 'slots',
}

export enum AccessoryTranslationType {
	NONE,
	SLOTS,
	FREE,
}

export type AccessoryHostingSlot = {
	childAccessoryName: string;
	adjustAxis: AxisIndex;
	object: Object3D;
};

export type AccessorySlot = {
	slug: string;
	name: string;
	position: Vector3Tuple;
	axis: AxisIndex;
	id: number;
};

export type AccessorySlotsData = {
	translationAxes: [
		AccessoryTranslationType,
		AccessoryTranslationType,
		AccessoryTranslationType,
	];
	min: Vector3Tuple;
	max: Vector3Tuple;
	translationSteps: Vector3Tuple;
	slots: AccessorySlot[];
	defaultSlots: [
		AccessorySlot | null,
		AccessorySlot | null,
		AccessorySlot | null,
	];
	initialPosition: Vector3Tuple;
	accessoriesUpperBoundLimitY?: number;
};

export type ModelSlotsData = Record<string, AccessorySlotsData>;

export enum ThreeEvent {
	DISTANCE = 'distance',
	SET_SLOTS_DATA = 'set_slots_data',
	SET_ACCESSORIES_IS_COLLIDING = 'set_accessories_is_colliding',
}

export type ThreeEvents = {
	[ThreeEvent.DISTANCE]: number;
	[ThreeEvent.SET_SLOTS_DATA]: ModelSlotsData;
	[ThreeEvent.SET_ACCESSORIES_IS_COLLIDING]: {
		refId: UUID;
		isColliding: boolean;
	}[];
};

export interface SerializedAccessory {
	id: UUID;
	collisionLayers: number[];
	selectedSlotId: number | null;
	position: Vector3Tuple;
	collidedAccessories: UUID[];
}

export type SerializedAccessoriesManager = {
	accessories: SerializedAccessory[];
};

export type SerializedRenderer = {
	objectsManager: SerializedAccessoriesManager;
};
